"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.instagramFetchPosts = exports.instagramFetchPostsResultSchema = exports.instagramFetchPostsArgsSchema = void 0;
var zod_1 = require("zod");
var common_1 = require("./common");
exports.instagramFetchPostsArgsSchema = zod_1.z.object({
    username: zod_1.z.string().describe('The Instagram username to fetch posts for'),
    postCount: zod_1.z.number().min(1).max(100).describe('Number of posts to fetch (max 100)'),
    emitMode: common_1.emitModeSchema.default('single').describe('The mode to emit the result in.'),
});
var instagramProfileSchema = zod_1.z.object({
    id: zod_1.z.string(),
    username: zod_1.z.string(),
    fullName: zod_1.z.string(),
    bio: zod_1.z.string(),
    followers: zod_1.z.number(),
    following: zod_1.z.number(),
    isPrivate: zod_1.z.boolean(),
    isVerified: zod_1.z.boolean(),
    profilePicUrl: zod_1.z.string().nullable(),
});
var instagramMusicInfoSchema = zod_1.z.object({
    artistName: zod_1.z.string().nullable(),
    songName: zod_1.z.string().nullable(),
    usesOriginalAudio: zod_1.z.boolean().nullable(),
    audioId: zod_1.z.string().nullable(),
});
var instagramPostSchema = zod_1.z.object({
    id: zod_1.z.string(),
    shortcode: zod_1.z.string(),
    caption: zod_1.z.string().nullable(),
    mediaUrl: zod_1.z.string().nullable(),
    mediaType: zod_1.z.string().nullable(),
    timestamp: zod_1.z.string().nullable(),
    likeCount: zod_1.z.number().nullable(),
    commentCount: zod_1.z.number().nullable(),
    musicInfo: instagramMusicInfoSchema.nullable().optional(),
});
exports.instagramFetchPostsResultSchema = zod_1.z.object({
    user: instagramProfileSchema,
    posts: zod_1.z.array(instagramPostSchema),
});
exports.instagramFetchPosts = (0, common_1.createEmitModeToolMetadata)({
    id: 'instagramFetchPosts',
    displayName: 'Instagram Fetch Posts',
    displayDescription: 'Fetch Instagram posts for a given username.',
    category: 'search',
    color: common_1.BRAND_COLORS.INSTAGRAM,
    backgroundColor: (0, common_1.createBgColor)(common_1.BRAND_COLORS.INSTAGRAM),
    icon: 'default',
    argsSchema: exports.instagramFetchPostsArgsSchema,
}, exports.instagramFetchPostsResultSchema);
